// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wHzlRVzkwojRNBVlTSwb{flex-direction:column;gap:8px;display:flex}.giGAyUs4HgjoFz6gM0qx [aria-label=MessageField]:not(:focus-within){border-color:var(--red-80)}.g49ETI3xU8g2UXWNFrfI{min-height:32px;color:var(--content-primary-tertiary);border:1px solid var(--border-neutral-default);border-radius:6px;flex-direction:row;justify-content:space-between;align-items:center;gap:4px;padding:8px;display:flex}.w1gyhADntQMGq4oOzI3v{align-items:center;gap:2px;display:flex}.vWYxAshgHkIDuLGJrnRr{padding:1px 4px!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message": `wHzlRVzkwojRNBVlTSwb`,
	"fieldError": `giGAyUs4HgjoFz6gM0qx`,
	"switchSection": `g49ETI3xU8g2UXWNFrfI`,
	"switchLabelContainer": `w1gyhADntQMGq4oOzI3v`,
	"comingSoonStatus": `vWYxAshgHkIDuLGJrnRr`
};
export default ___CSS_LOADER_EXPORT___;
